import api from './api';

/**
 * @param {string} level_id
 * @param {Object} params
 * @param {string} [params.batchid]
 * @param {string} [params.status]
 * @param {string} [params.perPage]
 * @param {string} [params.page]
 * @param {string} [params.orderBy]
 * @param {string} [params.order]
 * @param {string} [params.createdFrom]
 * @param {string} [params.createdTo]
 * @param {string} [params.redeemedFrom]
 * @param {string} [params.redeemedTo]
 * @param {string} [params.description]
 * @param {boolean} [useChinaUrl]
 * @returns {Promise<{
 *  countFiltered?: number
 *  countAll?: number
 *  tokens: {
 *      token_id: string
 *      status: 'NOT_REDEEMED' | 'REDEEMED' | 'DISABLED'
 *      date_of_start: null
 *      date_of_end: null
 *      description: string
 *      created_at: string
 *      user_id: null
 *      test_group_id: string | null
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tokens-getTokens
 */
export default async function getAllTokens(level_id, params = {}, useChinaUrl = false) {
    const { data } = await api.get(`levels/${level_id}/tokens`, {
        params,
        useChinaUrl
    });

    return data;
}